import {ApolloError} from '@apollo/client';

// mutation が失敗したときに画面に出す文言。サーバーが返した理由はそのまま出し、
// 通信の失敗だけ通信エラーにする（checkout/payment/form と同じ。#389・#245）
export const mutationErrorMessage = (error: unknown) =>
  (error instanceof ApolloError && error.graphQLErrors[0]?.message) ||
  '通信エラーが発生しました。';
